import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export let startAchievementManager = (
  badge_designs,
  badges,
  cert_designs,
  certificates
) => {
  const root = createRoot(document.getElementById('achievementManagerApp'))
  root.render(
    <App
      badgeDesigns={badge_designs}
      badges={badges}
      certDesigns={cert_designs}
      certificates={certificates}
    />
  )
}
